/**
 * Layout route that keeps a customer module's pages to companies running it.
 *
 * `/auth/me` reports the acting company's customer module (the viewed company
 * for a Proda user viewing as another one). When it is not `slug`, the page
 * would only collect 403 MODULE_NOT_ENABLED responses, so redirect to "/",
 * whose landing resolves to the pages this company does have (`/welcome` when
 * none). This also covers switching view-as while on such a page and opening a
 * bookmarked URL.
 */
import { Navigate, Outlet } from "react-router-dom";
import type { TUseAppStore } from "./types";

export const createRequireCustomerModule = (useAppStore: TUseAppStore) =>
    function RequireCustomerModule({ slug }: { slug: string }) {
        const user = useAppStore((state) => state.user);
        // Not loaded yet: the root layout decides what to show meanwhile.
        if (!user) {
            return <Outlet />;
        }
        if (user.customerModule?.slug !== slug) {
            return <Navigate to="/" replace />;
        }
        return <Outlet />;
    };
